import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { Paper, Typography, Button, TableContainer, Table, TableBody, TextField, TableHead, TableRow, TableCell } from '@mui/material';
import { TableLoader, Icon, InputWithIcon, AccessPortal, toast, ExpandedTooltip } from '@livable/saas-react-components';
import { TeamMemberMenu } from './TeamMemberMenu';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import AddTeamMemberV2Modal from 'src/components/settings/AddTeamMemberV2Modal';
import { EditTeamMemberV2Modal } from 'src/components/settings/EditTeamMemberV2Modal';
import { SimpleConfirmationModal } from 'src/components/shared/SimpleConfirmationModal';
import { USER_ROLES_BY_NAME, USER_ROLES_TO_NAME } from 'src/constants/userSetting';
import RippleEffect from 'src/components/general/RippleEffect';
import warningImg from 'src/img/warning.svg';
export const MyTeamDashboard = observer(() => {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    triggerRefresh = _useState4[0],
    setTriggerRefresh = _useState4[1];
  const _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    searchKey = _useState6[0],
    setSearchKey = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    triggerEditTeamMemberModal = _useState8[0],
    setTriggerEditTeamMemberModal = _useState8[1];
  const _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    modalTeamMemberData = _useState0[0],
    setModalTeamMemberData = _useState0[1];
  const _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    teamMembersList = _useState10[0],
    setTeamMembersList = _useState10[1];
  const fetchTeamMemberList = async () => {
    const teamMembersResp = await store.teamMembers.getCompanyTeamMembersAggregateAsync.run({});
    if (teamMembersResp !== null && teamMembersResp !== void 0 && teamMembersResp.isSuccessful) {
      var _teamMembersResp$resp;
      setTeamMembersList(teamMembersResp === null || teamMembersResp === void 0 || (_teamMembersResp$resp = teamMembersResp.response) === null || _teamMembersResp$resp === void 0 ? void 0 : _teamMembersResp$resp.teamMembers);
    }
  };
  const fetchData = async () => {
    setIsLoading(true);
    await fetchTeamMemberList();
    setIsLoading(false);
  };
  const _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    removeTeamMemberModalState = _useState12[0],
    setRemoveTeamMemberModalState = _useState12[1];
  const removeTeamMemberActionHandler = async _ref => {
    let action = _ref.action,
      objectToPassOver = _ref.objectToPassOver;
    setIsLoading(true);
    setRemoveTeamMemberModalState(false);
    if (action === 'submit') {
      const teamMembersResp = await store.teamMembers.deleteTeamMemberAsync.run({
        teamMemberId: objectToPassOver === null || objectToPassOver === void 0 ? void 0 : objectToPassOver.teamMemberId
      });
      if (teamMembersResp && teamMembersResp !== null && teamMembersResp !== void 0 && teamMembersResp.isSuccessful) {
        toast('success', {
          body: ['Team member deleted!']
        });
        setIsLoading(true);
        setTriggerRefresh(!triggerRefresh);
      }
    }
  };
  const handleResendInvite = async accountId => {
    const reInviteUserResp = await store.account.reInviteUserAsync.run(accountId);
    if (!reInviteUserResp || !reInviteUserResp.isSuccessful) return;
    toast('success', {
      body: ['Re-invitation successfully sent']
    });
  };
  useEffect(() => {
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerRefresh]);
  const AccessTooltip = _ref2 => {
    var _selectedTeamMember$p, _selectedTeamMember$p2, _selectedTeamMember$p3, _selectedTeamMember$p4, _selectedTeamMember$p5, _selectedTeamMember$p6, _selectedTeamMember$p7;
    let selectedTeamMember = _ref2.selectedTeamMember;
    const objToMap = {};
    selectedTeamMember === null || selectedTeamMember === void 0 || selectedTeamMember.portfolioAccessResponse.map(portfolio => {
      objToMap[portfolio.id] = _objectSpread({}, portfolio);
    });
    selectedTeamMember === null || selectedTeamMember === void 0 || selectedTeamMember.propertyAccessResponse.map(property => {
      var _objToMap$property$po;
      objToMap[property.portfolioId] = _objectSpread(_objectSpread({
        id: property.portfolioId,
        name: property.portfolioName
      }, objToMap[property.portfolioId]), {}, {
        properties: [...(((_objToMap$property$po = objToMap[property.portfolioId]) === null || _objToMap$property$po === void 0 ? void 0 : _objToMap$property$po.properties) || []), property]
      });
    });
    return /*#__PURE__*/React.createElement("div", {
      className: classes.accessTooltipContainer,
      key: "accessTooltipContainer-".concat(selectedTeamMember.teamMemberId)
    }, /*#__PURE__*/React.createElement("div", {
      className: "tooltip-header"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, selectedTeamMember.userRole === USER_ROLES_BY_NAME.PropertyManagerAccountHolder ? t('team_page.full_access') : "".concat(!!((_selectedTeamMember$p = selectedTeamMember.portfolioAccessResponse) !== null && _selectedTeamMember$p !== void 0 && _selectedTeamMember$p.length) ? ((_selectedTeamMember$p2 = selectedTeamMember.portfolioAccessResponse) === null || _selectedTeamMember$p2 === void 0 ? void 0 : _selectedTeamMember$p2.length) + " ".concat(((_selectedTeamMember$p3 = selectedTeamMember.portfolioAccessResponse) === null || _selectedTeamMember$p3 === void 0 ? void 0 : _selectedTeamMember$p3.length) <= 1 ? t('team_page.access_portfolio_singular') : t('team_page.access_portfolio_plural')).concat(!!((_selectedTeamMember$p4 = selectedTeamMember.propertyAccessResponse) !== null && _selectedTeamMember$p4 !== void 0 && _selectedTeamMember$p4.length) ? ',' : '') : '', " ").concat(!!((_selectedTeamMember$p5 = selectedTeamMember.propertyAccessResponse) !== null && _selectedTeamMember$p5 !== void 0 && _selectedTeamMember$p5.length) ? ((_selectedTeamMember$p6 = selectedTeamMember.propertyAccessResponse) === null || _selectedTeamMember$p6 === void 0 ? void 0 : _selectedTeamMember$p6.length) + " ".concat(((_selectedTeamMember$p7 = selectedTeamMember.propertyAccessResponse) === null || _selectedTeamMember$p7 === void 0 ? void 0 : _selectedTeamMember$p7.length) <= 1 ? t('team_page.access_property_singular') : t('team_page.access_property_plural')) : '')), /*#__PURE__*/React.createElement(Button, {
      variant: "actionButton",
      onClick: event => {
        event.stopPropagation();
        setModalTeamMemberData(selectedTeamMember);
        setTriggerEditTeamMemberModal(true);
      },
      'custom-attribute': '833-team-settings-page-my-team-dash'
    }, t('team_page.manage_access'))), /*#__PURE__*/React.createElement("div", {
      className: "tooltip-content"
    }, selectedTeamMember.userRole === USER_ROLES_BY_NAME.PropertyManagerAccountHolder ? /*#__PURE__*/React.createElement(Typography, {
      className: classes.fullAccessDesciption,
      variant: "body1"
    }, t('team_page.full_access_tooltip_description')) : Object.values(objToMap).map(value => {
      var _value$properties;
      return /*#__PURE__*/React.createElement("ul", {
        className: classes.mainList
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
        className: "".concat(classes.listItem, " rootListItem"),
        key: value.id
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "folder-house",
        state: "lightGrey"
      }), value.name), value === null || value === void 0 || (_value$properties = value.properties) === null || _value$properties === void 0 ? void 0 : _value$properties.map(property => /*#__PURE__*/React.createElement("li", {
        className: classes.listItem
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "building",
        state: "grey"
      }), /*#__PURE__*/React.createElement(Typography, {
        variant: "body2"
      }, property.name))))));
    })));
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, t('team_page.my_team')), /*#__PURE__*/React.createElement("div", {
    className: classes.actionButtons
  }, !store.account.userProfile.isUserPropertyManagerRegular && /*#__PURE__*/React.createElement(AddTeamMemberV2Modal, {
    customTrigger: /*#__PURE__*/React.createElement(Button, {
      size: "large",
      variant: "priority",
      'custom-attribute': '834-team-settings-page-my-team-dash'
    }, t('team_page.add_new_team_member')),
    triggerRefresh: () => setTriggerRefresh(!triggerRefresh)
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.searchSection
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    variant: "outlined",
    size: "small",
    className: classes.searchSectionInput,
    value: searchKey,
    onChange: event => setSearchKey(event.target.value),
    fullWidth: true,
    placeholder: t('team_page.search_team_member')
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.tableWrapper
  }, isLoading ? /*#__PURE__*/React.createElement(TableLoader, null) : !!teamMembersList && !!(teamMembersList !== null && teamMembersList !== void 0 && teamMembersList.length) && !!teamMembersList.filter(tm => {
    const searchPhrase = new RegExp(searchKey, 'gi');
    return searchKey.length > 0 ? " ".concat(tm.email).search(searchPhrase) > 0 || " ".concat(tm.newEmail).search(searchPhrase) > 0 || " ".concat(tm.firstName, " ").concat(tm.lastName).search(searchPhrase) > 0 : true;
  }).length ? /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    width: '300px',
    align: "left"
  }, t('team_page.name')), /*#__PURE__*/React.createElement(TableCell, {
    width: '250px',
    align: "left"
  }, t('general.email')), /*#__PURE__*/React.createElement(TableCell, {
    width: '300px',
    align: "left"
  }, t('general.phone')), /*#__PURE__*/React.createElement(TableCell, {
    width: '220px',
    align: "left"
  }, t('team_page.role')), /*#__PURE__*/React.createElement(TableCell, {
    width: '250px',
    align: "left"
  }, t('team_page.access')), !store.account.userProfile.isUserPropertyManagerRegular && /*#__PURE__*/React.createElement(TableCell, {
    width: '120px',
    align: "left"
  }, t('general.actions')))), /*#__PURE__*/React.createElement(TableBody, null, !!teamMembersList && !!(teamMembersList !== null && teamMembersList !== void 0 && teamMembersList.length) && teamMembersList.filter(tm => tm.isEnabled).filter(tm => {
    const searchPhrase = new RegExp(searchKey, 'gi');
    return searchKey.length > 0 ? " ".concat(tm.email).search(searchPhrase) > 0 || " ".concat(tm.newEmail).search(searchPhrase) > 0 || " ".concat(tm.firstName, " ").concat(tm.lastName).search(searchPhrase) > 0 : true;
  }).map(teamMember => {
    var _teamMember$portfolio, _teamMember$portfolio2, _teamMember$portfolio3, _teamMember$propertyA, _teamMember$propertyA2, _teamMember$propertyA3, _teamMember$propertyA4;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: teamMember.teamMemberId
    }, /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.tableFullNameCell
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.avatar
    }, " ", teamMember.firstName.toUpperCase().charAt(0)), /*#__PURE__*/React.createElement("div", {
      className: classes.tableFullNameText
    }, "".concat(teamMember.firstName, " ").concat(teamMember.lastName)), !!teamMember.emailConfirmed ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AccessPortal, {
      tooltipText: t('team_page.has_access_to_portal'),
      type: "success"
    })) : /*#__PURE__*/React.createElement("div", {
      onClick: () => {
        handleResendInvite(teamMember.accountId);
      }
    }, /*#__PURE__*/React.createElement(AccessPortal, {
      tooltipText: t('team_page.pending_invite'),
      type: "warning"
    })))), /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.tableEmailCell
    }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
      title: teamMember.email || teamMember.newEmail || 'N/A',
      placement: "top"
    }, /*#__PURE__*/React.createElement("span", null, teamMember.email || teamMember.newEmail || 'N/A')))), /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, teamMember.phone), /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, USER_ROLES_TO_NAME[teamMember.userRole]), /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, /*#__PURE__*/React.createElement(RippleEffect, {
      className: 'cellContent'
    }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
      className: classes.accessTooltip,
      title: /*#__PURE__*/React.createElement(AccessTooltip, {
        selectedTeamMember: teamMember
      }),
      type: "utilities-default",
      placement: "top"
    }, teamMember.userRole === USER_ROLES_BY_NAME.PropertyManagerAccountHolder ? t('team_page.full_access') : "".concat(!!((_teamMember$portfolio = teamMember.portfolioAccessResponse) !== null && _teamMember$portfolio !== void 0 && _teamMember$portfolio.length) ? ((_teamMember$portfolio2 = teamMember.portfolioAccessResponse) === null || _teamMember$portfolio2 === void 0 ? void 0 : _teamMember$portfolio2.length) + " ".concat(((_teamMember$portfolio3 = teamMember.portfolioAccessResponse) === null || _teamMember$portfolio3 === void 0 ? void 0 : _teamMember$portfolio3.length) <= 1 ? t('team_page.access_portfolio_singular') : t('team_page.access_portfolio_plural')).concat(!!((_teamMember$propertyA = teamMember.propertyAccessResponse) !== null && _teamMember$propertyA !== void 0 && _teamMember$propertyA.length) ? ',' : '') : '', " ").concat(!!((_teamMember$propertyA2 = teamMember.propertyAccessResponse) !== null && _teamMember$propertyA2 !== void 0 && _teamMember$propertyA2.length) ? ((_teamMember$propertyA3 = teamMember.propertyAccessResponse) === null || _teamMember$propertyA3 === void 0 ? void 0 : _teamMember$propertyA3.length) + " ".concat(((_teamMember$propertyA4 = teamMember.propertyAccessResponse) === null || _teamMember$propertyA4 === void 0 ? void 0 : _teamMember$propertyA4.length) <= 1 ? t('team_page.access_property_singular') : t('team_page.access_property_plural')) : '')))), !store.account.userProfile.isUserPropertyManagerRegular && /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, /*#__PURE__*/React.createElement(TeamMemberMenu, {
      key: 'TeamMemberMenuKey_' + teamMember.teamMemberId,
      selectedTeamMember: teamMember,
      menuTriggerExternal: /*#__PURE__*/React.createElement(Icon, {
        type: "dotdotdot",
        'custom-attribute': '835-team-settings-page-my-team-dash'
      }),
      handleShowEditTeamMemberModal: setTriggerEditTeamMemberModal,
      handleShowDeleteTeamMemberModal: () => setRemoveTeamMemberModalState(true),
      setModalTeamMemberData: setModalTeamMemberData
    })));
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    style: {
      textAlign: 'center'
    }
  }, t('team_page.no_team_members_found'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement("img", {
    alt: "team members missing data",
    src: warningImg,
    height: '300px',
    width: '100%'
  })))), /*#__PURE__*/React.createElement(EditTeamMemberV2Modal, {
    customTrigger: null,
    data: modalTeamMemberData,
    triggerRefresh: () => setTriggerRefresh(!triggerRefresh),
    handleTriggerShowModal: triggerEditTeamMemberModal,
    handleShowModal: value => setTriggerEditTeamMemberModal(value)
  }), /*#__PURE__*/React.createElement(SimpleConfirmationModal, {
    headerText: t('team_page.delete_team_member'),
    subTitleText: (modalTeamMemberData === null || modalTeamMemberData === void 0 ? void 0 : modalTeamMemberData.email) || (modalTeamMemberData === null || modalTeamMemberData === void 0 ? void 0 : modalTeamMemberData.newEmail),
    bodyText: t('team_page.you_are_about_to_delete', {
      firstName: modalTeamMemberData === null || modalTeamMemberData === void 0 ? void 0 : modalTeamMemberData.firstName,
      lastName: modalTeamMemberData === null || modalTeamMemberData === void 0 ? void 0 : modalTeamMemberData.lastName
    }),
    externalIsOpen: removeTeamMemberModalState,
    objectToPassOver: modalTeamMemberData,
    callBack: removeTeamMemberActionHandler,
    customTrigger: null
  }));
});